import React from 'react';
import './ResultModal.css';

const ResultModal = ({ 
  showResult, 
  gameResult
}) => {
  const getResultImage = () => {
    switch (gameResult) {
      case 'correct':
        return '/images/result_correct.png';
      case 'incorrect':
        return '/images/result_incorrect.png';
      case 'timesUp':
        return '/images/result_timesUp.png';
      default:
        return '';
    }
  };

  if (!showResult) return null;

  return (
    <div className="result-overlay">
      <div className="result-image-container">
        {getResultImage() ? (
          <img 
            src={getResultImage()} 
            alt="Result" 
            className="result-image"
          />
        ) : (
          <div className="result-text">
            {gameResult === 'correct' && 'Correct!'}
            {gameResult === 'incorrect' && 'Incorrect!'}
            {gameResult === 'timesUp' && 'Time\'s Up!'}
          </div>
        )}
      </div>
    </div>
  );
};

export default ResultModal; 